export enum StaticContentType {
  // Company Section
  ABOUT = 'ABOUT',
  CAREERS = 'CAREERS',
  BLOG = 'BLOG',
  PARTNERS = 'PARTNERS',
  
  // Pages Section
  TEAM = 'TEAM',
  PRICING = 'PRICING',
  GALLERY = 'GALLERY',
  SETTINGS = 'SETTINGS',
  PROFILE = 'PROFILE',
  LISTINGS = 'LISTINGS',
  
  // Quick Links Section
  LEGAL = 'LEGAL',
  PRIVACY = 'PRIVACY',
  TERMS = 'TERMS',
  REFUND = 'REFUND',
  SUPPORT = 'SUPPORT',
  TICKETS = 'TICKETS',
  FAQ = 'FAQ'
  
}
